import { SafetyCertificateOutlined } from '@ant-design/icons';
import { ColorPicker, Row } from 'antd';
import React from 'react';

const BHYTColorStatus: React.FC<{value: number}> = ({value}) => {
  switch(value) {
    case 1:
      return <SafetyCertificateOutlined style={{color: '#ff3300', fontSize: '24px'}}/> // Red
    case 2: 
      return <SafetyCertificateOutlined style={{color: '#e7a700', fontSize: '24px'}}/> //
    default:
      return <></>
  } 
};

export default BHYTColorStatus;